import React, { FC } from 'react';
import { Skeleton } from 'antd';

interface Props {
  style?: object,
}

const SkeletonLoader: FC<Props> = ({ style }) => (
  <div style={style}>
    <Skeleton.Input active block style={{ marginBottom: 12, width: '100%' }} size="small" />
    <Skeleton.Input active block style={{ marginBottom: 12, width: '100%' }} size="small" />
  </div>
);

export default SkeletonLoader;
